import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'acorn-goal-max-check',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './goal-max-check.component.html',
  styleUrls: ['./goal-max-check.component.scss'],
})
export class GoalMaxCheckComponent {
  @Output() close = new EventEmitter<void>();

  onClose(){
    this.close.emit();
  }
}
